import React from 'react';

const DETACHED_CONTROLS_BOTTOM = '24px';

export const useHeroVideoStateSync = ({
  heroVideoUrl,
  images,
  setCurrentSlideId,
  setIsHeroVideoPlaying,
}) => {
  React.useEffect(() => {
    setCurrentSlideId(heroVideoUrl ? '' : images[0]?.imgId || '');
  }, [heroVideoUrl, images, setCurrentSlideId]);

  React.useEffect(() => {
    setIsHeroVideoPlaying(false);
  }, [heroVideoUrl, setIsHeroVideoPlaying]);
};

export const useDetachedControlsPosition = ({
  heroCarouselRef,
  onNativeAutoplayButtonFound,
  imagesLength,
  isAutoPlay,
  setDetachedControlsPosition,
}) => {
  React.useEffect(() => {
    const heroCarouselElement = heroCarouselRef.current;
    let timeoutId = 0;
    let rafId = 0;
    let measurementAttempts = 0;

    const syncGalleryButtonPosition = () => {
      const controls = heroCarouselElement?.querySelector(
        '[class*="controls"]'
      );

      if (!heroCarouselElement || !controls) {
        timeoutId = window.setTimeout(syncGalleryButtonPosition, 50);
        return;
      }

      const nativeAutoplayButton = [
        ...controls.querySelectorAll('button'),
      ].find((button) =>
        (button.textContent || '')
          .toLowerCase()
          .includes('automatic slide show')
      );

      if (nativeAutoplayButton) {
        onNativeAutoplayButtonFound(nativeAutoplayButton);
        nativeAutoplayButton.style.display = 'none';
      }

      const heroBox = heroCarouselElement.getBoundingClientRect();

      if (!heroBox.width) {
        return;
      }

      const navToButtonsGap = Number.parseFloat(
        window
          .getComputedStyle(heroCarouselElement)
          .getPropertyValue('--nav-bar-pause-button-gap')
      );
      const resolvedNavToButtonsGap = Number.isFinite(navToButtonsGap)
        ? navToButtonsGap
        : 8;

      const detachedControls = heroCarouselElement.querySelector(
        '[class*="detachedControlsOverlay"]'
      );
      const detachedControlsWidth =
        detachedControls?.getBoundingClientRect().width || 0;
      const controlsCenterOffset = detachedControlsWidth
        ? (detachedControlsWidth + resolvedNavToButtonsGap) / 2
        : 0;

      heroCarouselElement.style.setProperty(
        '--detached-controls-center-offset',
        `${controlsCenterOffset}px`
      );

      const controlsBox = controls.getBoundingClientRect();

      if (!controlsBox.width) {
        return;
      }

      setDetachedControlsPosition({
        left: `${controlsBox.right - heroBox.left + resolvedNavToButtonsGap}px`,
        bottom: DETACHED_CONTROLS_BOTTOM,
      });

      if (!detachedControls && measurementAttempts < 6) {
        measurementAttempts += 1;
        rafId = window.requestAnimationFrame(syncGalleryButtonPosition);
      }
    };

    syncGalleryButtonPosition();
    window.addEventListener('resize', syncGalleryButtonPosition);

    return () => {
      window.clearTimeout(timeoutId);
      window.cancelAnimationFrame(rafId);
      window.removeEventListener('resize', syncGalleryButtonPosition);
      heroCarouselElement?.style.removeProperty(
        '--detached-controls-center-offset'
      );
      setDetachedControlsPosition(null);
    };
  }, [
    heroCarouselRef,
    onNativeAutoplayButtonFound,
    imagesLength,
    isAutoPlay,
    setDetachedControlsPosition,
  ]);
};
